import { createAction } from '../../store.model';
import { User } from '../../user/user.model';
import { ScorecardTab, ScorecardTabs } from '../main-page/scorecard.state';

export enum ActionType {
    SCORECARD_HEADER__RELOAD_TABS = 'SCORECARD_HEADER__RELOAD_TABS',
    SCORECARD_HEADER__SELECT_TAB = 'SCORECARD_HEADER__SELECT_TAB', // TODO revise. maybe rename to SYNC_TAB
    SCORECARD_HEADER__SELECT_USER = 'SCORECARD_HEADER__SELECT_USER',
    SCORECARD_HEADER__SELECT_USER_RESULT = 'SCORECARD_HEADER__SELECT_USER_RESULT',
}

export interface ReloadTabs {
    tabs: ScorecardTabs;
}

export const reloadTabs = createAction<ActionType, ReloadTabs>(
    ActionType.SCORECARD_HEADER__RELOAD_TABS,
);

/// ///////

export interface SelectTab {
    tab: ScorecardTab;
}

export const selectTab = createAction<ActionType, SelectTab>(
    ActionType.SCORECARD_HEADER__SELECT_TAB,
);

/// ///////

export interface SelectUser {
    /**
     * userId to pass to user-select component
     */
    userId?: number;
}

/**
 * invoked when button is clicked to open the user-select component
 */
export const selectUser = createAction<ActionType, SelectUser>(
    ActionType.SCORECARD_HEADER__SELECT_USER,
);

export interface SelectUserResult {
    /**
     * userId that was selected in the user-select component. may be null when no user was selected
     */
    userId?: number; // even though user is below, keep this for the time being until tab persistence is worked out

    user?: User;
}

/**
 * invoked when the user-select component closes
 */
export const selectUserResult = createAction<ActionType, SelectUserResult>(
    ActionType.SCORECARD_HEADER__SELECT_USER_RESULT,
);
